import Box from '@mui/material/Box';

import { getFieldsBySection } from '@/core/dcr/fields/registry';

import { useDcrFormContext } from '../_context/DcrFormContext';
import { AddFields } from '../AddFields/AddFields';
import { DcrField } from '../DcrField/DcrField';

import { entityFormStyles as sx } from './EntityForm.styles';

export const EntityForm = () => {
	const { entityType } = useDcrFormContext();

	return (
		<Box sx={sx.root}>
			{getFieldsBySection(entityType).flatMap(({ fields }) =>
				fields.map(({ key }) => <DcrField key={key} name={key} />)
			)}
			<AddFields />
		</Box>
	);
};
